export class ReconnectRestoreAwsOrganizationalUnitResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "organizationalUnit",
            "baseName": "organizationalUnit",
            "type": "RestoreAwsOrganizationalUnit",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ReconnectRestoreAwsOrganizationalUnitResponse.attributeTypeMap;
    }
    constructor() {
    }
}
